module.exports = __webpack_public_path__ + "img/adg-problem-gambling.dee8d9e1.png";